import type {
  CategoriesEntity,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';

import { CategoryMenu, CategoryMenuItem } from '@eliadmin/core/src/components/header/category-menu';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { isOrganizedOffersMenuItem } from './menu-item-identity';

export type HeaderMenuProps = {
  menu: Menu;
  categories: CategoriesEntity[];
  className?: {
    root?: string;
    wrapper?: string;
  };
};

export function HeaderMenu({ menu, categories, className }: HeaderMenuProps) {
  const fields = menu.fields.filter(item => !isOrganizedOffersMenuItem(item.path));
  return (
    <div
      className={cn(
        'flex max-w-full flex-wrap items-center gap-2',
        'ea-header-menu',
        className?.wrapper,
      )}
    >
      <CategoryMenu className={cn('ea-header-menu', className?.root)}>
        {fields.map((item, index) => {
          return (
            <CategoryMenuItem
              key={item.path}
              href={item.path}
              title={item.name}
              index={index}
              isLast={index === fields.length - 1}
              categories={categories}
            />
          );
        })}
      </CategoryMenu>
    </div>
  );
}
